module.exports = __webpack_public_path__ + "img/img-sobre-nos.294ee8ff.png";